import { gql } from '__generated__';

export default gql(`
  mutation AddTeam($input: AddTeamInput!) {
    addTeam(input: $input) {
      ...TeamFieldsFragment
    }
  }
`);
